import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@assets/images/icons/pdf_primary.svg'


const _hoisted_1 = { class: "contributions-tables cobra-payments" }
const _hoisted_2 = { class: "contributions-table-wrapper" }
const _hoisted_3 = { class: "contributions-table-item no-striped" }
const _hoisted_4 = { class: "d-flex w-100 align-items-center justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "This screen displays a record of payments you have made towards COBRA continuation coverage.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Invoice #"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Due Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance"),
    /*#__PURE__*/_createElementVNode("th", null, "View Invoice")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('N/A'), -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pdf"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, "No invoices found.")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "d-flex w-100 justify-content-center justify-content-md-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-tertiary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('coverage-history', 'Coverage History', '', null, null, null, null, { plan: 'COBRA' })), ["prevent"]))
          }, "Coverage History ")
        ]),
        _hoisted_5,
        _createElementVNode("table", null, [
          _hoisted_6,
          (_ctx.cobraPayments.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cobraPayments, (cobraPayment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: cobraPayment.InvoiceID
                  }, [
                    _createElementVNode("td", null, _toDisplayString(cobraPayment.InvoiceID), 1),
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(cobraPayment.CoveragePeriod), 1),
                    _createElementVNode("td", null, _toDisplayString(cobraPayment.DueDate), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(cobraPayment.Status) + " ", 1),
                      (cobraPayment.Status == 'Unpaid')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "link-text text-300 d-block",
                            onClick: _withModifiers(($event: any) => (_ctx.openModal('hw-cobra-statements', 'Make COBRA Payment', 'plan-upload plan-card-info plan-c-mrp-claims', null, null, null, {InvoiceID: cobraPayment.InvoiceID})), ["prevent"]),
                            href: "#"
                          }, "Pay Invoice", 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(cobraPayment.Amount)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(cobraPayment.Balance)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: "javascript;",
                        onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: cobraPayment.DocumentID })), ["prevent"])
                      }, _hoisted_12, 8, _hoisted_10)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_13, _hoisted_15))
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.showMore)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "btn btn-primary plan-modal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('hw-cobra-payments-history', 'Payment History', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
              }, " More "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}